import { render, staticRenderFns } from "./chartsCombination.vue?vue&type=template&id=64f995e2&scoped=true"
import script from "./chartsCombination.vue?vue&type=script&lang=js"
export * from "./chartsCombination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f995e2",
  null
  
)

export default component.exports